import type { SVGProps } from "react";
export interface ChartLineStarIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ChartLineStarIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ChartLineStarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 11.5V6c0-1.036-.84-1.875-1.875-1.875H6c-1.036 0-1.875.84-1.875 1.875v12c0 1.035.84 1.875 1.875 1.875h5l.115.006a1.125 1.125 0 0 1 0 2.238l-.116.006H6A4.125 4.125 0 0 1 1.875 18V6A4.125 4.125 0 0 1 6 1.875h12A4.125 4.125 0 0 1 22.125 6v5.5a1.125 1.125 0 0 1-2.25 0"
      />
      <path
        fill={color}
        d="M16.878 13.953a1.378 1.378 0 0 1 2.244 0l.105.177.837 1.667 1.882.271c1.035.148 1.538 1.365.9 2.183l-.142.157-1.351 1.292.318 1.822c.202 1.16-1.016 1.949-1.983 1.449L18 22.098l-1.688.873c-.967.5-2.185-.29-1.983-1.449l.316-1.822-1.349-1.292c-.844-.81-.345-2.182.758-2.34l1.88-.27.839-1.668zm.804 3.381c-.165.33-.482.557-.847.61l-.672.095.473.452c.271.26.394.637.33 1.007l-.116.662.634-.327.123-.054c.295-.11.625-.092.909.054l.632.327-.114-.662c-.064-.37.059-.747.33-1.007l.471-.452-.67-.096a1.13 1.13 0 0 1-.847-.609L18 16.701zm-1.977-8.63a1.125 1.125 0 1 1 1.59 1.591l-2.698 2.699c-.69.689-1.76.82-2.595.319l-1.079-.646-2.628 2.628a1.125 1.125 0 1 1-1.59-1.59l2.698-2.698.133-.123a2.13 2.13 0 0 1 2.303-.284l.16.088 1.076.644z"
      />
    </svg>
  );
}
